import { render } from "./TheLoading.vue?vue&type=template&id=ec45eea8"
import script from "./TheLoading.vue?vue&type=script&lang=js"
export * from "./TheLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__